import type {ComponentProps, PropsWithChildren} from 'react'
import {Heading} from '@primer/react'
import {BetaLabel} from '@github-ui/lifecycle-labels/beta'
import {useSlots} from '@primer/react/experimental'
import {useStatic} from '../contexts/StaticContext'

Header.Actions = Actions

export {Header}

const headerSlotConfig = {
  actions: Header.Actions,
}

function Header({
  title,
  subtitle,
  as,
  children: slottedChildren,
}: PropsWithChildren<{title: string; subtitle?: string; as?: ComponentProps<typeof Heading>['as']}>) {
  const {isPreview} = useStatic()
  const [{actions}] = useSlots(slottedChildren, headerSlotConfig)
  return (
    <div className="d-flex flex-row flex-items-center flex-justify-between">
      <div>
        <Heading as={as ?? 'h2'} variant="large" className="d-flex gap-1 flex-items-center text-semibold f4">
          {title}&nbsp;{isPreview ? <BetaLabel /> : null}
        </Heading>
        {subtitle ? <span className="color-fg-muted">{subtitle}</span> : null}
      </div>
      {actions}
    </div>
  )
}

function Actions({children}: PropsWithChildren) {
  return children
}
Actions.displayName = 'PanelList.Header.Actions'
